"use strict";

exports.__esModule = true;
var _DeviceListScreen = require("./DeviceListScreen");
Object.keys(_DeviceListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceListScreen[key]) return;
  exports[key] = _DeviceListScreen[key];
});